import React, {useState} from 'react';
import styles from '../styles.module.scss';
import Checkbox from '../../../../../shared/components/checkbox';
import InfoTooltip from '../../../../../shared/components/info-tooltip';
import CollapsibleSection from '../../../../components/collapsible-section';
import classnames from 'classnames';
import {EVENT_NOTIFICATIONS} from './integration-utils';
import AdminUniversityService from '../../../../services/AdminUniversityService';
import req from '../../../../../shared/req';
import {flashMessage} from '../../../../../shared/actions/notifications';
import {useDispatch} from 'react-redux';
import useAsyncEffect from '../../../../hooks/use-async-effect';

interface Props {
  universityId: string;
}

const EventSubscriptions = ({universityId}: Props) => {
  const [eventNotifications, setEventNotifications] = useState<string[]>([]);
  const dispatch = useDispatch();

  const updateEventSubscription = async (code: string, enable: boolean): Promise<void> => {
    try {
      await req({
        url: `/v1/admin/university/${universityId}/update-event-notification/${code}`,
        method: 'PATCH',
        data: {enable},
      });

      setEventNotifications((prev) =>
        enable ? [...prev, code] : prev.filter((notification) => notification !== code)
      );

      dispatch(flashMessage('Event Notification Updated'));
    } catch (error) {
      console.log({error});
    }
  };

  useAsyncEffect(() => fetchUniversity());

  const fetchUniversity = async () => {
    try {
      const response = await AdminUniversityService.show(universityId);
      setEventNotifications(response.university.eventNotifications);
    } catch (error) {
      console.error(error);
    }
  };

  const eventNotificationsWithStatus = EVENT_NOTIFICATIONS.map((notification) => ({
    ...notification,
    checked: eventNotifications.includes(notification.code),
  }));

  return (
    <div className={styles.editCollegeProfile}>
      <div className={styles.header}>
        <p className="shared-font title">Event Subscriptions</p>
      </div>
      <div className="mt-32">
        <CollapsibleSection title="User Events" className={styles.collapsibleSection}>
          {eventNotificationsWithStatus.map(({code, name, tooltipText, checked}) => (
            <div key={name} className={classnames('mt-8', styles.eventFlexDiv)}>
              <div className={styles.nameContainer}>
                <p className="shared-font body m-0">
                  {code} - {name}
                </p>
                <InfoTooltip>{tooltipText}</InfoTooltip>
              </div>
              <div className={styles.checkboxContainer}>
                <Checkbox
                  checked={checked}
                  key={name}
                  // defaultChecked
                  onClick={() => updateEventSubscription(code, !checked)}
                  aria-label="Turn on/off event"
                />
              </div>
            </div>
          ))}
        </CollapsibleSection>
      </div>
    </div>
  );
};

export default EventSubscriptions;
